import classNames from 'classnames';
import React, { HTMLProps } from 'react';
import './HorizontalDescriptionList.scss';

export type HorizontalDescriptionListProps = HTMLProps<HTMLDListElement>;

export const HorizontalDescriptionList = ({
  className,
  ...props
}: HorizontalDescriptionListProps) => (
  <dl className={classNames('horizontal-description-list', className)} {...props} />
);
